import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BasicInfoDetail from "./BasicInfo/BasicInfoDetail";

export default function DrmPfDetail() {
  const [tabValue, setTabValue] = useState<string | null>("api");
  const navigate = useNavigate();

  return (
    <div>
      <div className="sub-header">
        <ul className="uk-tab uk-margin">
          <li>
            <Link to="/drm_pf/api">利用料</Link>
          </li>
          <li>
            <Link to="/basic_info">基本情報</Link>
          </li>
          <li className="uk-active">
            <Link to="/drm_pf/info">DRM-PF</Link>
          </li>
          <li>
            <Link to="/ticket">DRM-Chat</Link>
          </li>
        </ul>
      </div>
      <div className="container">
        <ul className="uk-tab attribute-tab">
          <li className="uk-active">
            <Link className="leading-1" to="/drm_pf/info">
              DRM-PF
              <br />
              基本情報
            </Link>
          </li>
          <li>
            <Link className="h-75" to="/drm_pf/download">
              資料ダウンロード
            </Link>
          </li>
        </ul>
        <BasicInfoDetail />
      </div>
    </div>
  );
}
